import { Directive, HostListener, input } from '@angular/core';
import { Router } from '@angular/router';
import { EditorItemsService, EditorItemType, EditorListItem } from '../services/editor-items.service';
import { RouteShareService } from '../services/route-share.service';
import { EmbedBotBroadcastService } from 'src/app/embed-bot-broadcast.service';

export interface GotoBlocklyContext {

  contextId: string;
  editorType: EditorItemType;
}

/* eslint-disable @angular-eslint/directive-selector */
@Directive({
  selector: '[gotoBlockly]',
  standalone: true
})
/* eslint-enable @angular-eslint/directive-selector */
export class GotoBlocklyDirective {
  public readonly editorItem = input.required<EditorListItem | undefined>({ alias: "gotoBlockly" });
  constructor(private router: Router, private editorService: EditorItemsService, private rss: RouteShareService, private embedBotBroadcast: EmbedBotBroadcastService) { }
  @HostListener('click')
  public onClick() {

    const editorItem = this.editorItem();
    console.log("GO TO BLOCKLY", editorItem);
    if (editorItem) {
      this.editorService.seletItem(editorItem);

      void this.router.navigate(['/', 'bot-admin', this.rss.botConfig._id, 'blockly']);
      this.embedBotBroadcast.informationsChanged$.next(editorItem);
    }
  }
}
